import React from "react";
import { useAuthorization } from "../../hooks/useAuthorization";
import { Navigate } from "react-router-dom";
import PixelEdumanLoader from "../loading/PixelEdumanLoader";

/**
 * @typedef {Object} ContentItem
 * @property {Element} element
 * @property {String} accessControl
 */

/**
 * @param {{contents: ContentItem[], redirect: Boolean}} props 
 * @returns {JSX.Element}
 * Takes an array of objects like so: 
 * 
 * [
 * 
 *      {
 *          element: <MasterPlanView />,
 *          accessControl: "*"
 *      },
 *      {
 *          element: <DMPlanView />,
 *          accessControl: "planDM"
 *      },
 *      {
 *          element: <CMPlanView />,
 *          accessControl: "planCM"
 *      },
 *      ...
 * ] 
 * 
 * -- and checks against their accessControl property to see if you are authorized to receive them.
 * 
 * If no element is authorized you are booted to the home page
 */
const ProtectedRouteSwitch = ({contents, redirect = true}) => {
    const {checkAccessControl} = useAuthorization();

    let returningElement = "no element found";

    for(const elementObj of contents) {
        if(returningElement === "no element found") {
            const el = elementObj.element;
            const ac = elementObj.accessControl;
    
            const [isAuthorized, loading] = checkAccessControl(ac);
            
        
            if(loading) {
                return (<PixelEdumanLoader message={"Loading..."} isAbsolute={true} />)
            }

            if(isAuthorized) {
                returningElement = el;
            }
        }  
    };

    if(returningElement === "no element found") {
        returningElement = <></>;
        
        if(redirect) {
            returningElement = <Navigate to={"/client/home"} />;
        }
    }
    
    return returningElement;
}

export default ProtectedRouteSwitch;